import { OnInit, OnDestroy, Injectable, inject } from '@angular/core';
import { EventManager } from '../../core';
import { Subject, Subscription } from 'rxjs';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

import { debounceTime } from 'rxjs/operators';

@Injectable({ providedIn: 'any' })
export abstract class ModalComponent implements OnInit, OnDestroy {
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  callApi$ = new Subject();
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    public eventManager: EventManager,
  ) {

  }
  ngOnInit() {
    this.subsCommon = [...[
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);})
    ]];
    Object.keys(this).forEach((key) => {
      if (typeof this[key] !== 'function' && this.nzModalData[key]) {
        this[key] = this.nzModalData[key];
      }
    })
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
    this.eventManager.destroys(this.subsCommon);
  }
  callAPI(event) {}
}
